module.exports = __webpack_public_path__ + "media/buzzer_takeaway.a40bb893.webm";